import { DelegateProvider } from '../../shared/interfaces/delegate-provider.interface';
import { PromotionDisplayDetails } from '../../shared/models/promotion-display-details.model';
import { PromotionType } from '../services/datastore-service/models/raw-promotion.model';

export const kNameOfPromotionWindowManagerService =
  'PromotionWindowManagerService';

// -----------------------------------------------------------------------------
export interface IPromotionWindowManagerServiceDelegate {
  onPromotionWindowClosed?(
    info: PromotionDisplayDetails,
    visibleTimeInMs: number,
  );
  onPromotionDismissed?(info: PromotionDisplayDetails);
  onPromotionReachedMinTimeToDisplay?(info: PromotionDisplayDetails);
}

// -----------------------------------------------------------------------------
// This is the background interface for PromotionWindowServiceImpl - which
// communicates with the Promotion window
export interface IPromotionWindowManagerService
  extends DelegateProvider<IPromotionWindowManagerServiceDelegate> {
  show(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    isTester?: boolean,
    useDevEnv?: string,
  );
  close();
  isPromotionShown(): Promise<boolean>;
  getPromotionInfo(): PromotionDisplayDetails;
}
